'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.DataLoaderPanel', []).constant('DataLoaderPanelConstants', require('./constants/DataLoaderPanelConstants')).directive('rmDataLoaderPanel', require('./directives/DataLoaderPanelDirective'));